<template>
  <!--顶部条-->
  <div id="fixd">
      <!--导航栏-->
      <div class="nav">
          <div class="nav_con">
            <img class="nav_con-logo" src="../assets/images/logo.png">
            <div class="nav_list">
                <el-menu :default-active="activeIndex" text-color="#333333" active-text-color="#D52C00" mode="horizontal" @select="handleSelect">
                    <el-menu-item index="/home/index">首页</el-menu-item>
                    <el-menu-item index="/home/service">保函服务</el-menu-item>
                    <el-menu-item index="/home/inspection">保函查询</el-menu-item>
                    <el-menu-item index="/home/about">关于我们</el-menu-item>
                </el-menu>
            </div>
            <div class="nav_con_right u-flex">
                <div class="top_login_btn">
                    <router-link v-if="!userObjName" to="/home/login">登录/注册</router-link>
                    <el-dropdown v-if="userObjName" class="select_person" trigger="hover" @command="handleCommand">
                        <span class="el-dropdown-link">
                            <router-link to="/home/personal">个人中心</router-link>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="退出">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div></div>
                <div class="nav_con_rtxt">
                    {{userObjName}}
                </div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import  {sesStorage}  from '@/model/storage.js'
import Qs from "qs";
export default {
    data(){
        return{
            activeIndex:'',
            userObjName:''
        }
    },
    components:{},
    watch:{
    $route:{
        handler(val,oldval){
             this.activeIndex=val.path;
        },
        // 深度观察监听
        deep: true
        }
    },
    methods:{
        handleSelect(val){
            if(val=='/home/service' || val=='/home/inspection'|| val=='/home/about'){
                 this.$router.push({path:val});
            }else{
                if (!sesStorage.get('userObj')) {
                    this.$router.push({path:"/home/login"});
                }else{
                    this.$router.push({path:val});
                }
            }
           
        },
        handleCommand(command) {
            if(command=="退出"){
                this.layOut()
            }
        },    
        layOut(){
            this.$message({
                message: '退出成功',
                type: "success",
                center: true,
              });
            setTimeout(()=>{
                sesStorage.remove('userObj');
                this.userObjName='';
                this.$router.push({
                    path:'/home/login'
                })
            },100)
            
        }
    },
    created(){
        window.addEventListener('setItem', ()=> {
            if(sesStorage.get('userObj')){
                this.userObjName = sesStorage.get('userObj').company;
            }
        })
        window.addEventListener('removeItem', ()=> {
                this.userObjName = '';
        })
    },
    mounted(){
         this.activeIndex=this.$route.path;

         if(sesStorage.get('userObj')){
                this.userObjName = sesStorage.get('userObj').company;
            }
    }
}
</script>


<style lang="scss" scoped>

a{
    text-decoration: none;
    color: inherit;
}

h1, h2 {
    margin: 0;
}

ul, li {
    list-style: none;
}

a {
    text-decoration: none;
    list-style: none;
    color: inherit;
}

.header_top{
    font-size: 14px;
    background-color: #F2F2F2;
    color: #999999;
    line-height: 40px;
    height: 40px;
    .header_top_center{
        width: 1100px;
        margin: 0 auto;
        .pull-right{
            margin-right: 20px;
            overflow: hidden;
            & *{
                float: left;
            }
            .login_name{
                font-weight: bold;
                color: #333333;
                margin: 0 4px;
            }
            .line_t{
                width: 1px;
                height: 22px;
                background-color: #999999;
                display: inline-block;
                margin: 9px 20px;
            }
        }
        
    }
}
.layOut{
    cursor: pointer;
}
.nav {
    position: relative;
    margin: 0 auto;
    overflow: hidden;
    background-color: #fff;
    font-size: 16px;
    padding: 35px 0 35px 0;
}

.nav li {
    list-style: none;
}

.nav_con {
    width: 1500px;
    overflow: hidden;
    margin: 0 auto;
}

.nav_con-logo {
    float: left;
    margin-top: 10px;
}

.nav_list {
   float: left;
   margin-left: 100px;
   .el-menu.el-menu--horizontal{
       border: none;
   }
   .el-menu-item{
        margin: 0 25px;
        padding: 0 10px;
        font-size: 16px;
        line-height: 74px;
        height: 74px;
        border: none;
    }
    .el-menu--horizontal>.el-menu-item.is-active {
        border: none;
    }
}
.nav_con_right{
    float: right;
    line-height: 74px;
}
.nav_con_rtxt{
    font-size: 20px;
    color: #303643;
    font-weight: bold;
}
.top_login_btn{
    margin-right: 56px;
    .select_person{
        font-size: 16px;
        cursor: pointer;
    }
}


</style>


// WEBPACK FOOTER //
// src/views/Header.vue